export default "__VITE_ASSET___rG3BAfQlc5MQ9WnjLncrw__"